import InvoiceHtmlBuilder from "./InvoiceHtmlBuilder";

export default class DeliveryNoteHtmlBuilder extends InvoiceHtmlBuilder {
    get allowedColumns() {
        return ["title", "product", "quantity"]
    }

    protected get buildVATAndTotalBox(): string {
        return `
            <div class="col d-flex justify-content-end px-0px pt-24px">
                <strong>Nom et signature du client</strong>
            </div>
        `
    }

    protected get buildDepositsRowsBox(): string {
        return ''
    }

    protected get buildPaymentDetailsBlock(): string {
        return ''
    }
}